<template>
  <div>
    <a-modal v-model="visible" :width="this.settings['isMobileView'] ? 480 : 720" title="Create Inward Transaction"
      onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Save</a-button>
      </template>
      <div class="row">
        <div class="col-12">
          <h4>{{ oldrecord.name }}</h4>
          <p class="mb-2">
            Product Code: <span class="font-weight-bold">{{ oldrecord.code }}</span> | Balance Qnty.: <span
              class="font-weight-bold">{{ oldrecord.product_stock == null ? 0 : oldrecord.product_stock.quantity }}</span>
          </p>
        </div>
      </div>
      <hr>
      <a-form class="mb-4" :form="form">
        <div class="row">
          <div class="col-md-4 mb-2">
            <a-form-item label="Quantity">
              <a-input-number style="width: 100%" :min="0"
                v-decorator="['quantity', { initialValue: '0' }, { rules: [{ required: true, message: 'Please input quantity!' }] }]" />
            </a-form-item>
          </div>
          <div class="col-md-4 mb-2">
            <a-form-item label="Unit Price">
              <a-input-number style="width: 100%" v-decorator="['unitPrice', { initialValue: '0.0' }]" />
            </a-form-item>
          </div>
          <div class="col-md-4 mb-2">
            <a-form-item label="Date">
              <a-date-picker style="width: 100%"
                v-decorator="['transactionDate', { rules: [{ required: false, message: 'Please input date' }], initialValue: moment() },]"
                :format=dateFormat />
            </a-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-2">
            <a-form-item label="Invoice No." class="mb-2">
              <a-input v-decorator="['invoiceNo']" />
            </a-form-item>
          </div>
          <div class="col-md-6 mb-2">
            <a-form-item label="Supplied By" class="mb-2">
              <a-input v-decorator="['suppliedBy']" />
            </a-form-item>
          </div>
        </div>
        <!--        <div class="row">
          <div class="col-md-6 mb-2">
            <a-form-item label="Brought By" class="mb-2">
              <a-input
                v-decorator="['broughtBy']"
              />
            </a-form-item>
          </div>
          <div class="col-md-6 mb-2">
            <a-form-item label="Received By" class="mb-2">
              <a-input
                v-decorator="['receivedBy']"
              />
            </a-form-item>
          </div>
        </div>-->
        <!-- Select  -->
        <div class="row align-items-center mb-2">
          <div class="col-md-6 col-12 mb-2">
            <a-form-item label="Brought By" class="mb-2">
              <a-select show-search size="default" v-model="selectedBroughtBy" placeholder="Search Staff.."
                optionFilterProp="children" style="width: 100%" @change="handleChange" @search="searchStaffs"
                :filterOption="true" :defaultValue="undefined">
                <a-select-option :value="0">
                  All Staffs
                </a-select-option>
                <template v-for="staff in staffs">
                  <a-select-option :value="staff.id" :key="staff.id">
                    {{ staff.first_name }} {{ staff.last_name }} ({{ staff.staff_id }})
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-md-6 col-12 mb-2">
            <a-form-item label="Received By" class="mb-2">
              <a-select show-search size="default" v-model="selectedReceivedBy" placeholder="Search Staff.."
                optionFilterProp="children" style="width: 100%" @change="handleChangeReceivedBy" @search="searchStaffs"
                :filterOption="true" :defaultValue="undefined">
                <a-select-option :value="0">
                  Select Staffs
                </a-select-option>
                <template v-for="staff in staffs">
                  <a-select-option :value="staff.id" :key="staff.id">
                    {{ staff.first_name }} {{ staff.last_name }} ({{ staff.staff_id }})
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 mb-2">
            <a-form-item label="Remark" class="mb-2">
              <a-input v-decorator="['remark']" />
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'InwardTransaction',
  data: function () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      oldrecord: {},
      newrecord: {},
      dateFormat: 'DD-MM-YYYY',
      selectedBroughtBy: null,
      selectedReceivedBy: null,
      staffSearch: null,
      staffs: [],
      staffsMeta: {},
      staffCurrent: 1,
      staffPageSize: 10,
      staffSpinning: false,
    }
  },
  mounted: function () {
    this.$eventBus.$on('showInwardTransactionForm', this.showForm)
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  methods: {
    moment,
    showForm: function(record) {
      this.visible = true
      // console.log('passed record', record)
      this.oldrecord = record
      this.getStaffs()
      setTimeout(() => {
        this.form.setFieldsValue({
          'name': record.name,
          'code': record.code,
          'balanceQuantity': (record.product_stock === null || record.product_stock === undefined) ? 0 : record.product_stock.quantity,
        })
      }, 50)
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    handleEdit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        console.log('Inward qty', values.totalInwardQuantity)
        if (!err) {
          this.$http
            .post(`/api/inventory/transaction/inward`, {
              product_id: this.oldrecord.id,
              quantity: values.quantity,
              price: values.unitPrice,
              date: values.transactionDate.format('YYYY-MM-DD HH:mm:ss'),
              invoice_no: values.invoiceNo,
              supply_by: values.suppliedBy,
              brought_by: this.selectedBroughtBy,
              received_by: this.selectedReceivedBy,
              remark: values.remark,
              transaction_subtype: 0,

            })
            .then((resp) => {
              if (resp.status === 200) {
                this.loading = false
                this.visible = false
                this.$emit('onInwardTransaction')
                this.$notification['success']({
                  message: 'Quantity added successfully',
                  description: 'Quantity added successfully',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data.',
                })
              }
              this.form.resetFields()
              this.selectedBroughtBy = null
              this.selectedReceivedBy = null
              this.oldrecord = {}
            })
            .catch(error => {
              this.$neoNotify.error(error)
            })
        }
      })
      this.loading = false
    },
    getStaffs: function(isSearch) {
      this.staffSpinning = true

      let page = this.staffCurrent
      if (isSearch) {
        page = 1
        this.staffCurrent = 1
      }
      this.$http.get('/api/staff', {
        params: {
          limit: this.staffPageSize,
          search: this.staffSearch,
          page: page,
        },
      }).then(({ data }) => {
        this.staffs = data.data
        this.staffSpinning = false
        this.staffsMeta = data.meta
      })
    },
    searchStaffs: function(value) {
      if (value) {
        this.staffSearch = value
        this.getStaffs(true)
      }
    },

    handleChange: function (value) {
      if (value) {
        this.selectedBroughtBy = value
      }
    },

    handleChangeReceivedBy: function (value) {
      if (value) {
        this.selectedReceivedBy = value
      }
    },
  },
}
</script>

<style>

</style>
